var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "elpg.ods@gmail.com") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4C8.489 4 4 8.489 4 14v22c0 5.511 4.489 10 10 10h22c5.511 0 10-4.489 10-10V14c0-5.511-4.489-10-10-10H14zm-1 12h24c.18 0 .35.02.51.07l-9.83 9.82a3.801 3.801 0 0 1-5.37 0l-9.82-9.82c.16-.05.33-.07.51-.07zm-1.93 1.49L18.59 25l-7.52 7.51c-.05-.16-.07-.33-.07-.51V18c0-.18.02-.35.07-.51zm27.86 0c.05.16.07.33.07.51v14c0 .18-.02.35-.07.51L31.4 25l7.53-7.51zM20 26.41l.89.9a5.782 5.782 0 0 0 4.1 1.69c1.49 0 2.97-.56 4.1-1.69l.9-.9 7.52 7.52c-.16.05-.33.07-.51.07H13c-.18 0-.35-.02-.51-.07L20 26.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.033453a42584e3e829755fb28471c5ba.svg";
export { ForwardRef as ReactComponent };